<template>
    <div>
        <el-dialog
            :title="title"
            :visible.sync="visible"
            :show-close="false"
            :close-on-click-modal="false"
            class="qcode-dialog"
            width="464px"
            v-on:close="close"
        >
            <div v-if="!isPublic" class="qrcode-content">
                <i
                    class="el-icon-circle-close"
                    aria-hidden="true"
                    v-on:click.stop="$emit('dialog-close')"
                />
                <div class="tip">{{ tipInfo.tip }}</div>
                <div class="qrcode-body">
                    <div class="qrcode-item">
                        <qr-code :url="wxUrl"></qr-code>
                        <qr-code :url="appUrl"></qr-code>
                    </div>
                    <div class="guide">
                        <div class="guide-item">
                            <div>方法一:</div>
                            <div v-html="tipInfo.method1"></div>
                        </div>
                        <div class="guide-item">
                            <div>方法二:</div>
                            <div v-html="tipInfo.method2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import qrCode from "@/components/fund/qrCode";

export default {
    name: "QrCodeGuide",
    components: { qrCode },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        isPublic: {
            type: Boolean,
            default: false
        },
        fundcode: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "和讯财富 专注资产稳增长"
        },
        tipInfo: {
            type: Object,
            default: function () {
                return {
                    tip: "您可选择以下任一方法至移动端完成基金购买",
                    method1: '<span class="red">微信扫码完成基金购买</span>',
                    method2: '<span class="red">使用理财客APP</span> ，扫码完成基金购买'
                };
            }
        }
    },
    data() {
        return {
            visible: false,
            appImgUrl: "", // APP下载二维码
            wxUrl: "",
            appUrl: ""
        };
    },
    watch: {
        dialogVisible(value) {
            if (value) {
                if (this.isPublic) {
                    // this.title = "请到APP下单购买";
                    // 公募购买二维码链接
                    this.appImgUrl = this.$cache.getCompanyInfoParam("10106001");
                    if (
                        window.caifulib &&
                        window.caifulib.default &&
                        window.caifulib.default.open
                    ) {
                        this.$emit("dialog-close"); // 公募产品使用HX提供弹窗组件
                        window.caifulib.default.open({
                            code: this.fundcode,
                            type: "gm"
                        });
                    }
                } else {
                    // 私募购买二维码链接
                    let wxPrefix = this.$cache.getCompanyInfoParam("10102009") || "";
                    let appPrefix = this.$cache.getCompanyInfoParam("10102010") || "";
                    this.wxUrl = `${wxPrefix}/#/pages/privatefund/funddetail/index?fundcode=${this.fundcode}`;
                    this.appUrl = `${appPrefix}/#/pages/privatefund/funddetail/index?fundcode=${this.fundcode}`;
                }
            }
            this.visible = value;
        }
    },
    methods: {
        close() {
            this.$emit("dialog-close");
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .qcode-dialog {
    .el-icon-circle-close {
        position: absolute;
        right: 24px;
        top: 24px;
        font-size: 16px;
        color: #fff;
    }
    .el-dialog {
        background: url(../../assets/img/qrcode-bg.png) no-repeat;
        background-color: #fff;
        border-radius: 5px;
    }
    .el-dialog__header {
        font-weight: 700;
        text-indent: 111px;
        padding: 23px 20px 10px;
        .el-dialog__title {
            font-size: 16px;
            color: #606266;
        }
    }
    .el-dialog__body {
        padding: 0;
    }
    .qrcode-content {
        padding-bottom: 24px;
        .tip {
            font-size: 14px;
            line-height: 24px;
            text-align: center;
        }
    }
    .qrcode-body {
        margin: 0 24px 14px;
        padding: 8px 23px 0;
        border-radius: 5px;
        background-color: #fff;
        .qrcode-item {
            display: flex;
            align-items: center;
            justify-content: space-around;
        }
        .guide {
            margin-top: 2px;
            font-size: 12px;
            line-height: 20px;
            display: flex;
            .guide-item {
                width: 50%;
            }
        }
    }
    .red {
        color: #bf292f;
    }
}
</style>
